module.exports = __webpack_public_path__ + "static/media/avatar_user.b1d2d8c8.svg";